<template>
  <div class="layout-menu-add-on layout-menu-add-on-start">
    <img v-if="appState.user.imageUrl" class="layout-menu-user-avatar border-circle" :src="appState.user.imageUrl" alt="avatar" :onerror="'this.onerror=null;this.src=\''+ defaultUser + '\';'" referrerpolicy="no-referrer" />
    <div v-else class="layout-menu-user-initial flex align-items-center justify-content-center overflow-hidden border-circle text-xl">
      <span v-if="appState.user.givenName && appState.user.familyName">
        {{`${appState.user.givenName.charAt()}${appState.user.familyName.charAt()}`}}
      </span>
      <span v-else class="mb-1">@</span>
    </div>
    <span class="layout-menu-user-information">
      <span class="font-bold" data-cy="AppMenuUser_user-name">{{`${appState.user.givenName} ${appState.user.familyName}`}}</span>
      <small data-cy="AppMenuUser_user-email">{{appState.user.email}}</small>
    </span>
  </div>
</template>

<script setup>
  import { inject } from "vue";
  import defaultUser from "@/images/default-user.png";
  const appState = inject("appState");
</script>